import { ActivityType } from "../enums/activityType"
import { TFunction } from "i18next"

export const getType = (type:ActivityType, t: TFunction) => {
    switch (type) {
      case ActivityType.FREE:
        return t('loogbook.free')
      case ActivityType.AUTOMATIC:
        return t('loogbook.automatic')
      case ActivityType.PROGRAMMED:
        return t('loogbook.programmed')
      default:
        return ''
    }
  }